import { NULL_VALUE, URL_SHOP_PART_NUMBER } from "../../helper/constants";
import { utilAnalytics } from "../../components/common/analytics/analyticsUtil";
let globalFrameHeight = 0;
// Global addAnalytics function for adding analytic data
/* eslint-disable */
export function addAnalytics(data) {
  if (data) {
    const jasonData = JSON.stringify({
      key: "analytics",
      value: data,
    });
    //pushing analytics data to parent
    parent?.window?.postMessage(jasonData, "*");
  }
}
//number to plainString
function toPlainString(num) {
  return ("" + +num).replace(
    /(-?)(\d*)\.?(\d*)e([+-]\d+)/,
    function (a, b, c, d, e) {
      return e < 0
        ? b + "0." + Array(1 - e - c.length).join(0) + c + d
        : b + c + d + Array(e - d.length + 1).join(0);
    }
  );
}
//Function to sent updated height to iframe
/* eslint-disable */
export function resizeParent(extraHeight = 0) {
  try {
    const elmBody = window.document?.body;
    const elmHtml = window.document?.documentElement;
    if (elmBody && elmHtml) {
      setTimeout(function () {
        let frameHeight = elmHtml.offsetHeight + Math.floor(elmHtml.scrollTop);
        if (frameHeight != globalFrameHeight) {
          if (extraHeight > 0) {
            globalFrameHeight = frameHeight + extraHeight;
          } else {
            globalFrameHeight = frameHeight;
          }
          parent.window.postMessage(globalFrameHeight, "*");
        }
      }, 100);
    }
  } catch {}
}
//scroll to top
export function scrollToParentTop() {
  parent?.window?.postMessage(
    JSON.stringify({ key: "scrolltop", value: "" }),
    "*"
  );
}

/**
 * Checks if a variable is and object with properties
 * @param {*} obj - The variable to check
 * @returns true if the variable obj is an object and contains properties, otherwise returns false
 */
export const isObjectWithProperties = (obj) => {
  return typeof obj === "object" && Object.keys(obj).length > 0;
};

  function GetEnvDetails() {
    var currentHostName = window.location.host.toLowerCase();
    var EnvObj = [
      {
        appId: "43h67650rzv2",
        hostname: "devaerotechpubs.reactapp.honeywellaerospace.com",
        domainId: "43h67650rzv21",
      },
      {
        appId: "vhiuce9425zh",
        hostname: "qaaerotechpubs.reactapp.honeywellaerospace.com",
        domainId: "vhiuce9425zh1",
      },
      {
        appId: "y1hlbe2e8zp1",
        hostname: "stageaerotechpubs.reactapp.honeywellaerospace.com",
        domainId: "y1hlbe2e8zp11",
      },
      {
        appId: "mdq8ac4e8if9",
        hostname: "techpubs.honeywellaerospace.com",
        domainId: "mdq8ac4e8if91",
      },
    ];
    return EnvObj.find((obj) => obj.hostname === currentHostName) || {};
  }

/**
 * Fetch SSO url depending on the current environment
 * @returns {string} - The current environment SSO url
 */
export const aemSiteLink = () => {
  var envDetails = GetEnvDetails();
  var appId =
    $('input[name\x3d"app_id"]').val() !== undefined
      ? $('input[name\x3d"app_id"]').val()
      : envDetails.appId;
  var aemSiteUrl = "";
  "y1hlbe2e8zp1" == appId && (aemSiteUrl = "https://stage.honeywellaerospace.com");
  "43h67650rzv2" == appId &&
    (aemSiteUrl = "https://dev.honeywellaerospace.com");
  "vhiuce9425zh" == appId &&
    (aemSiteUrl = "https://qa.honeywellaerospace.com");
  "mdq8ac4e8if9" == appId && (aemSiteUrl = "https://www.honeywellaerospace.com");
  var userInfo = $('input[name\x3d"user-info-URI"]').val();
  var apiUrl = userInfo;
  var Redirect_SSO =
    aemSiteUrl +
    "/pif/cwa/oauth/request/j_security_check?resource\x3d" +
    window.location.href +
    "\x26appId\x3d" +
    appId;
  return Redirect_SSO;
};

/**
 * Return analytics url to be use in the Launch script
 * @returns string url
 */
export const getAnalyticstLaunchScriptEnv = () => {
  var envDetails = GetEnvDetails();

  var appId =
    $('input[name\x3d"app_id"]').val() !== undefined
      ? $('input[name\x3d"app_id"]').val()
      : envDetails.appId;

  let analyticsUrl = "";

  "y1hlbe2e8zp1" == appId &&
    (analyticsUrl =
      "https://assets.adobedtm.com/dc5e650599bd/454c1f2652ff/launch-d95e1f2b4882-staging.min.js");
  "43h67650rzv2" == appId &&
    (analyticsUrl =
      "https://assets.adobedtm.com/dc5e650599bd/454c1f2652ff/launch-bbace5ea8538-development.min.js");
  "vhiuce9425zh" == appId &&
    (analyticsUrl =
      "https://assets.adobedtm.com/dc5e650599bd/454c1f2652ff/launch-9a7d9a2fe2bc-development.min.js");
  "mdq8ac4e8if9" == appId &&
    (analyticsUrl =
      "https://assets.adobedtm.com/dc5e650599bd/454c1f2652ff/launch-04c7348d2cd7.min.js");

  return analyticsUrl;
};

/**
 * THIS FUNCTION CONVERT STRING ARRAY INTO A LINK ARRAY THAT
 * REDIRECT TO PART NUMBER SHOP PAGE
 * @param {*} value array of strings
 * @param {*} valueLength length of the array
 * @returns array of A tags
 */
export const parseToLink = (value, valueLength,pubid) => {
  const pattern = /\bSeries?.*/gi;

  if (typeof value === "string") {
    if (value === NULL_VALUE) return value.toString();

    let valueLink = value;

    // only text containing "Series" or Serie will be trimmed.
    if (pattern.test(value)) {
      valueLink = value.replace(pattern, "").trim();
    }
      const handleClick1 = (valueLink,pubid) => {
      // handle click logic here
     const { protocol, host, hostname } = window.location;
     const onlyHostName = hostname
       .split(".")
       .find((item) => item.includes("aerotechpubs") && item);
       utilAnalytics(
       true,
       {
         pageName: `${onlyHostName}`,
         eVar163:`${pubid} | ${valueLink}`,
         linkType: "o",
         linkName: "Clicks on PartNumbers in AeroTechpubs",
       },
        ''
     );
    };

    return (
      <a
        key={`singleItem-${value}`}
        target="_blank"
        href={`${URL_SHOP_PART_NUMBER}/${valueLink}`}
        onClick={() => handleClick1(valueLink,pubid)}
      >
        {value}
      </a>
    );
  }

  if (!value || value.length === 0) {
    return NULL_VALUE;
  }

  const ary1 = [...value];
  const elementsToProcess =
    ary1.length > valueLength ? ary1.splice(0, valueLength) : ary1;

  if (ary1.includes("N") && ary1.includes("A")) {
    return ary1.toString().replace(/,/g, "");
  }

  return elementsToProcess.flatMap((item, index, arr) => {
    let itemLink = item;
    // only text containing "Series" or Serie will be trimmed.
    if (pattern.test(item)) {
      itemLink = item.replace(pattern, "").trim();
    }
    const  handleClick = (itemLink,pubid) => {
      const { protocol, host, hostname } = window.location;
        const onlyHostName = hostname
          .split(".")
          .find((item) => item.includes("aerotechpubs") && item);
          utilAnalytics(
          true,
          {
            pageName: `${onlyHostName}`,
            eVar163:`${pubid} | ${itemLink}`,
            linkType: "o",
            linkName: "Clicks on PartNumbers in AeroTechpubs",
          },
           ''
        );
       };
    return [
      <a
        key={index}
        target="_blank"
        href={`${URL_SHOP_PART_NUMBER}/${itemLink}`}
        onClick={() => handleClick(itemLink,pubid)} 
      >
        {item}
      </a>,
      index < arr.length - 1 ? ", " : "",
    ];
  });
};
